import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  initTheme(config: { colorPrimary: string | null | undefined }) {
    if (config.colorPrimary) {
      document.documentElement.style.setProperty(
        '--primary',
        config.colorPrimary
      );
    }
  }
}
